import { createApp, h } from 'vue'
import { createInertiaApp } from '@inertiajs/vue3'

// Auto-import all pages from app/frontend/pages
const pages = import.meta.glob('../../frontend/pages/**/*.vue')

createInertiaApp({
  resolve: (name) => {
    const importPath = `../../frontend/pages/${name}.vue`
    const importPage = pages[importPath]
    if (!importPage) {
      throw new Error(`Unknown Inertia page: ${name}`)
    }
    return importPage()
  },
  setup({ el, App, props, plugin }) {
    createApp({ render: () => h(App, props) })
      .use(plugin)
      .mount(el)
  },
})
